var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5195,
    cy: 78.5195,
    r: 78.5195,
    fill: "#4AACC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4191 67.8729V116.702H119.66L78.5396 76.011L62.0914 92.2873L37.4191 67.8729ZM94.9878 47.5275C94.9878 50.7651 96.2875 53.87 98.601 56.1593C100.914 58.4486 104.052 59.7348 107.324 59.7348C110.596 59.7348 113.733 58.4486 116.047 56.1593C118.36 53.87 119.66 50.7651 119.66 47.5275C119.66 44.29 118.36 41.185 116.047 38.8957C113.733 36.6064 110.596 35.3203 107.324 35.3203C104.052 35.3203 100.914 36.6064 98.601 38.8957C96.2875 41.185 94.9878 44.29 94.9878 47.5275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.5b571377d2554737f2ba8f97dda1c82d.svg";
export { ForwardRef as ReactComponent };